import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import CrossSellingProducts from '../CrossSellingProducts/CrossSellingProducts';
import Image from 'src/view/components/Image/Image';
import ImageSlider from 'src/view/components/ImageSlider/ImageSlider';
import { localeStore } from '~/mobx/localesStore';
import './style.scss';

const ProductImageBlock: React.FC = observer((): JSX.Element => {
  const { product, productError, crossSellingProducts, crossSellingLoading } = orderProductModalStore;

  const isCrossSelling = useMemo((): boolean => {
    return Boolean(product && (crossSellingProducts.length || crossSellingLoading));
  }, [product, crossSellingProducts, crossSellingLoading]);

  const ratio: number = useMemo(() => (isCrossSelling ? 2.5 : 1.5), [isCrossSelling]);

  return (
    <div className="product-block product-images pb-4 pb-lg-0">
      {product ? (
        <ImageSlider aspectRatio={ratio} images={product.images} className={classNames('product-images__slider', { 'opacity-50': productError })} />
      ) : (
        <Image aspectRatio={ratio} />
      )}

      {productError ? <span className="product-images__unavailable-msg letter-spacing-12">{localeStore.t(productError)}</span> : null}

      {isCrossSelling ? <CrossSellingProducts /> : null}
    </div>
  );
});

export default ProductImageBlock;
